import BuildingIcon from "@/assets/colorable/building.svg?react";
import InfoIcon from "@/assets/colorable/info_outline.svg?react";
import LockIcon from "@/assets/colorable/lock.svg?react";
import RightArrowIcon from "@/assets/colorable/right_arrow.svg?react";
import TickIcon from "@/assets/colorable/tick.svg?react";
import RefluencedLogo from "@/assets/images/refluenced.svg";
import Button from "@/components/Common/Button";
import clsxm from "@/lib/clsxm";
import useRegistrationStore from "@/store/registration";
import {type FC} from "react";

const RegistrationTopView: FC<{isRefluencedLogoVisible?: boolean}> = ({isRefluencedLogoVisible = true}) => {
  const step = useRegistrationStore(state => state.step);
  const isCredentialsStepValidated = useRegistrationStore(state => state.stepValidations.credentials);
  const isCompanyDetailsStepValidated = useRegistrationStore(state => state.stepValidations.company_details);
  const validateCredentials = useRegistrationStore(state => state.validateCredentials);
  const validateCompanyDetails = useRegistrationStore(state => state.validateCompanyDetails);
  const setValue = useRegistrationStore(state => state.setValue);

  const goBack = () => {
    if (step === "company_details") {
      setValue("step", "credentials");
    } else if (step === "interest_selection") {
      setValue("step", "company_details");
    }
  };
  const goToNextPage = useRegistrationStore(state => state.goToNextPage);

  const shouldShowForwardButton =
    step === "credentials"
      ? isCredentialsStepValidated
      : step === "company_details"
        ? isCompanyDetailsStepValidated
        : false;

  return (
    <div className="flex w-full flex-col items-center gap-10">
      <div className="flex w-full justify-between">
        {step !== "credentials" ? (
          <button onClick={goBack}>
            <RightArrowIcon className="text-primary-sky size-4 shrink-0 rotate-180" />
          </button>
        ) : (
          <div className="w-4.25" />
        )}
        <div className="flex items-center justify-center gap-3">
          <Button
            onClick={() => setValue("step", "credentials")}
            className={
              "flex size-10 items-center justify-center rounded-full border transition-all duration-150 " +
              (step === "credentials"
                ? "border-primary-medium-solid bg-primary-dark-solid"
                : "border-success-light-green bg-success-herbal")
            }>
            {step === "credentials" && !isCredentialsStepValidated ? (
              <LockIcon className="size-5 shrink-0 text-white" />
            ) : (
              <TickIcon className="size-5 shrink-0 text-white" />
            )}
          </Button>
          <div
            className={
              "h-0.5 w-4 rounded-full transition-all duration-150 " +
              (step === "credentials"
                ? "bg-neutral-grey-light"
                : step === "company_details"
                  ? "bg-primary-dark-solid"
                  : "bg-success-herbal")
            }
          />
          <Button
            isDisabled={!isCredentialsStepValidated}
            onClick={() => validateCredentials() && setValue("step", "company_details")}
            className={clsxm(
              "flex size-10 items-center justify-center rounded-full border transition-all duration-150 disabled:cursor-not-allowed disabled:active:scale-100",
              step === "company_details" ? "border-primary-medium-solid bg-primary-dark-solid" : "",
              step === "interest_selection" || (isCompanyDetailsStepValidated && step !== "company_details")
                ? "border-success-light-green bg-success-herbal"
                : "",
              step === "credentials" && !isCompanyDetailsStepValidated
                ? "border-neutral-grey-light bg-primary-light-solid"
                : "",
            )}>
            {step === "company_details" && !isCompanyDetailsStepValidated ? (
              <BuildingIcon className="size-5 shrink-0 text-white" />
            ) : step === "interest_selection" || isCompanyDetailsStepValidated ? (
              <TickIcon className="size-5 shrink-0 text-white" />
            ) : (
              <BuildingIcon className="text-neutral-grey-light size-5 shrink-0" />
            )}
          </Button>
          <div
            className={
              "h-0.5 w-4 rounded-full transition-all duration-150 " +
              (step !== "interest_selection" ? "bg-neutral-grey-light" : "bg-primary-dark-solid")
            }
          />
          <Button
            isDisabled={!isCredentialsStepValidated || !isCompanyDetailsStepValidated}
            onClick={() => validateCompanyDetails() && validateCredentials() && setValue("step", "interest_selection")}
            className={
              "flex size-10 items-center justify-center rounded-full border transition-all duration-150 disabled:cursor-not-allowed disabled:active:scale-100 " +
              (step === "interest_selection"
                ? "border-primary-medium-solid bg-primary-dark-solid"
                : "border-neutral-grey-light bg-primary-light-solid")
            }>
            {step === "interest_selection" ? (
              <InfoIcon className="size-5 shrink-0 text-white" />
            ) : (
              <InfoIcon className="text-neutral-grey-light size-5 shrink-0" />
            )}
          </Button>
        </div>
        {shouldShowForwardButton ? (
          <button onClick={goToNextPage}>
            <RightArrowIcon className="text-primary-sky size-4 shrink-0" />
          </button>
        ) : (
          <div className="w-4.25" />
        )}
      </div>
      {isRefluencedLogoVisible && (
        <div className="size-20 shrink-0">
          <img src={RefluencedLogo} className="size-full object-contain" />
        </div>
      )}
    </div>
  );
};

export default RegistrationTopView;
